import React from 'react';

export function PartnerLogos({ variant = 'light', className = '' }) {
  const dark = variant === 'dark';
  return (
    <div className={`flex items-center justify-center gap-8 ${className}`} data-testid="partner-logos">
      <img
        src={dark ? '/ibpap-logo-white.png' : '/ibpap-logo-color.png'}
        alt="IBPAP — IT & Business Process Association of the Philippines"
        className="h-7 object-contain"
        data-testid="footer-ibpap-logo"
      />
      <img
        src={dark ? '/sustek-logo-white.png' : '/sustek-logo-color.webp'}
        alt="SusTek"
        className="h-7 object-contain"
        data-testid="footer-sustek-logo"
      />
    </div>
  );
}
